import * as React from "react";
import { SVGProps } from "react";
const SvgRadioCheckboxRing02 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#radio-checkbox-ring-02_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M30 16c0-7.7-6.3-14-14-14l-.311.003C8.13 2.17 2 8.404 2 16c0 7.7 6.3 14 14 14s14-6.3 14-14ZM0 16C0 7.2 7.2 0 16 0s16 7.2 16 16-7.2 16-16 16S0 24.8 0 16Zm16-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="radio-checkbox-ring-02_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRadioCheckboxRing02;
